<template>
    <div class="weeduc-admin-page__toolbar-field-row">
        <v-text-field
            :model-value="filters.search"
            :label="labels.search"
            variant="outlined"
            density="compact"
            hide-details
            clearable
            append-inner-icon="mdi-magnify"
            class="inputd weeduc-admin-v-field collab-filters__search"
            @update:model-value="patch('search', $event)"
        />
        <v-select
            :model-value="filters.sectorId"
            :items="sectorOptions"
            item-title="text"
            item-value="value"
            :label="labels.sector"
            variant="outlined"
            density="compact"
            hide-details
            clearable
            class="inputd weeduc-admin-v-field"
            @update:model-value="patch('sectorId', $event)"
        />
        <v-select
            :model-value="filters.roleId"
            :items="roleOptions"
            item-title="text"
            item-value="value"
            :label="labels.role"
            variant="outlined"
            density="compact"
            hide-details
            clearable
            class="inputd weeduc-admin-v-field"
            @update:model-value="patch('roleId', $event)"
        />
        <v-select
            :model-value="filters.status"
            :items="statusOptions"
            item-title="text"
            item-value="value"
            :label="labels.status"
            variant="outlined"
            density="compact"
            hide-details
            clearable
            class="inputd weeduc-admin-v-field"
            @update:model-value="patch('status', $event)"
        />
        <v-select
            :model-value="filters.managerUserId"
            :items="managerOptions"
            item-title="text"
            item-value="value"
            :label="labels.manager"
            variant="outlined"
            density="compact"
            hide-details
            clearable
            class="inputd weeduc-admin-v-field"
            @update:model-value="patch('managerUserId', $event)"
        />
        <v-select
            :model-value="filters.type"
            :items="typeOptions"
            item-title="text"
            item-value="value"
            :label="labels.gestor"
            variant="outlined"
            density="compact"
            hide-details
            clearable
            class="inputd weeduc-admin-v-field"
            @update:model-value="patch('type', $event)"
        />
    </div>
</template>

<script>
import { CORPORATE_USER_TYPE } from '@/utils/corporate/users';

export default {
    name: 'CollaboratorFilters',
    props: {
        filters: {
            type: Object,
            required: true,
        },
        labels: Object,
        sectorOptions: { type: Array, default: () => [] },
        roleOptions: { type: Array, default: () => [] },
        managerOptions: { type: Array, default: () => [] },
    },
    emits: ['update:filters'],
    computed: {
        statusOptions() {
            return [
                { text: this.labels.all, value: null },
                { text: this.labels.active, value: 'active' },
                { text: this.labels.inactive, value: 'inactive' },
            ];
        },
        typeOptions() {
            return [
                { text: this.labels.all, value: null },
                { text: this.labels.gestor, value: CORPORATE_USER_TYPE.GESTOR },
                { text: this.labels.collaboratorFilter, value: CORPORATE_USER_TYPE.COLABORADOR },
            ];
        },
    },
    methods: {
        patch(key, value) {
            this.$emit('update:filters', { ...this.filters, [key]: value });
        },
    },
};
</script>

<style scoped>
.collab-filters__search {
    flex: 1.6 1 220px;
}
</style>
